// storyRegionDomain comes from the /api/config endpoint, which is set per-region since each
// region has its own Static Web App deployment (see StoryRegionDomain app setting)
export const getStoryUrl = (storyRegionDomain: string, sessionId: string | null): string => {
  return `${storyRegionDomain}/${sessionId ?? ""}`;
};
